import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-block-properties-pv.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-block-properties-pv.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { forkJoin, map, Observable, of, Subscription, take, tap } from "rxjs";
import { MapService } from "../../../../../map/shared/map.service";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { RequestStatusService } from "../../../../../shared/services/request-status/request-status.service";
import { ViewApplicationService } from "../../../view-application.service";
import Polygon from "@arcgis/core/geometry/Polygon";
import GeometryUtils from "../../../../../shared/utils/geometry-utils";
import { WktConverterUtils } from "../../../../../shared/utils/wkt-converter-utils";
import { FormGroup, FormControl, Validators, FormArray } from "@angular/forms";
import { ViewBlockPropertiesPvConstants } from "./view-block-property-pv.constant";
import { ViewBlockPropertiesPvService } from "./view-block-properties-pv.service";
import { DatePipe } from "@angular/common";
import { ViewApplicationLocationPvConstants } from "../view-application-location-pv/view-application-location-pv.constants";
import { ViewEditPropertyDetailsPvConstants } from "./view-edit-property-pv/view-edit-properties.constant";
import { AutoUnsub } from "../../../../../shared/decorators/autounsub.decorator";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ValuationPropertyHeadingLookup } from "../../../../../step/modules/pv/shared/pv-property-heading-model";
import { RecipientListService } from "../../../../../shared/components/recipient-list/shared/recipient-list.service";
import { PropertyValuationService } from "../../../../../shared/services/modules/property-valuation.service";
import { AlertType } from "../../../../../shared/models/alert";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { PopUpComponent } from "../../../../../shared/components/pop-up/pop-up.component";
import RecipientUtils from "../../../../../shared/utils/recipient-utils";
import { AppControllerService } from "../../../../../app-controller.service";
import { ReportService } from "src/app/shared/components/report-form/report.service";
import { getPropertyFieldCardLink, handleReportDownload, setMunicipalFieldCardParameters, setPublicFieldCardParameters } from "../shared/field-card-report-function";
import { ValuationPropertyTableHeadingEnum } from "../view-application-location-pv/prperty-table-headers";
let ViewBlockPropertiesPvComponent = class ViewBlockPropertiesPvComponent extends ApplicationBaseComponent {
    viewBlockPropertiesPvService;
    recipientSelectService;
    propertyValuationService;
    mapService;
    appControllerService;
    route;
    requestStatusService;
    viewApplicationService;
    routerParamsService;
    aflaModuleStrategyService;
    datePipe;
    modalService;
    changeDetectorRefs;
    reportService;
    mapComponent;
    selectedPropertyGraphic;
    pvApplication;
    showMap;
    isMapLoaded;
    tableDataSource = [];
    propertyTypesOptions = [];
    propertyLayerName = "Valuation block properties";
    saveBtnPlaceholder = ViewBlockPropertiesPvConstants.SAVE_BUTTON_PLACEHOLDER;
    propertyDetailsTab = ViewBlockPropertiesPvConstants.PROPERTY_DETAILS_TAB;
    valuationTab = ViewBlockPropertiesPvConstants.VALUATION_TAB;
    dropdownPlaceHolder = ViewBlockPropertiesPvConstants.PLACEHOLDER_SELECT_VALUATION;
    selectValuationLabel = ViewBlockPropertiesPvConstants.SELECT_VALUATION_LABEL;
    openMarketLbl = ViewBlockPropertiesPvConstants.OPEN_MARKET_VALUE_LABEL;
    openMarketCtrl = ViewBlockPropertiesPvConstants.OPEN_MARKET_VALUE_CONTROL;
    methodLbl = ViewBlockPropertiesPvConstants.METHOD_LABEL;
    statusLbl = ViewBlockPropertiesPvConstants.STATUS_LABEL;
    methodCtrl = ViewBlockPropertiesPvConstants.METHOD_CONTROL;
    valuationFormName = ViewBlockPropertiesPvConstants.VALUATION_FORM;
    propertyDetailsFormName = ViewBlockPropertiesPvConstants.PROPERTY_DETAILS_FORM;
    selectDateCtrl = ViewBlockPropertiesPvConstants.SELECT_DATE_CONTROL;
    improvementCtrl = ViewBlockPropertiesPvConstants.IMPROVEMENT_VAL_CONTROL;
    improvementLbl = ViewBlockPropertiesPvConstants.IMPROVEMENT_LABEL;
    calculationDateCtrl = ViewBlockPropertiesPvConstants.CALCULATION_DATE_CONTROL;
    calculationDateLbl = ViewBlockPropertiesPvConstants.CALCULATION_DATE_LABEL;
    multiValuesLbl = ViewBlockPropertiesPvConstants.MULTIVALUES_LABEL;
    selectPromptMessage = SharedConstants.NO_ITEM_SELECTED;
    selectOneItemMessage = SharedConstants.MORE_THAN_ONE_SELECTED;
    statusMap = ViewBlockPropertiesPvConstants.Statuses;
    editLabel = SharedConstants.EDIT_LABEL;
    deleteLabel = SharedConstants.DELETE_LABEL;
    cancelLabel = SharedConstants.CANCEL_LABEL;
    updateLabel = SharedConstants.UPDATE_LABEL;
    zoningLayer;
    blockSymbol = {
        type: "simple-fill",
        color: [255, 0, 0],
        style: "none",
        outline: {
            color: [255, 0, 0],
            width: 2
        },
        width: 2
    };
    selectedSymbol = {
        type: "simple-fill",
        color: [0, 255, 255],
        style: "none",
        outline: {
            color: [0, 255, 255],
            width: 2
        },
        width: 2
    };
    options = {
        size: "lg",
        centered: true,
        backdrop: "static",
    };
    ownerGroups = [];
    selectedPvPt;
    sketch;
    selectedGraphic;
    propertyToView;
    propertyLayer;
    pvValuations;
    selectPvValuation;
    mainForm;
    tableDataSourceObs = new Observable();
    tableMapper;
    deletePvPropretyObs;
    idVal = -1;
    postPvPropretiesObs;
    patchPvPropretiesObs;
    noItem = SharedConstants.NO_ITEMS_AVAILABLE_MESSAGE;
    zones = [];
    subscriptions = new Subscription;
    blockLayerName = "Valuation block";
    deletePvPropretySubscription;
    zoningFilterString = "1=1";
    propertyType;
    fieldCardLinkLabel = ValuationPropertyTableHeadingEnum.PublicFieldCard;
    fieldCardMunicipalLinkLabel = ValuationPropertyTableHeadingEnum.MunicipalFieldCard;
    get propertyDetailsForm() {
        return this.mainForm.get(this.propertyDetailsFormName);
    }
    constructor(viewBlockPropertiesPvService, recipientSelectService, propertyValuationService, mapService, appControllerService, route, requestStatusService, viewApplicationService, routerParamsService, aflaModuleStrategyService, datePipe, modalService, changeDetectorRefs, reportService) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.viewBlockPropertiesPvService = viewBlockPropertiesPvService;
        this.recipientSelectService = recipientSelectService;
        this.propertyValuationService = propertyValuationService;
        this.mapService = mapService;
        this.appControllerService = appControllerService;
        this.route = route;
        this.requestStatusService = requestStatusService;
        this.viewApplicationService = viewApplicationService;
        this.routerParamsService = routerParamsService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.datePipe = datePipe;
        this.modalService = modalService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.reportService = reportService;
    }
    ngAfterViewInit() {
        this.mapService.actionPropertyEnabled = true;
    }
    ngOnInit() {
        this.subscribeToProperty();
        this.initMainForm();
        this.listenForRouteParamChange();
        this.tableMapper = ValuationPropertyHeadingLookup;
    }
    updatePvDetailsForm(e) {
        const index = this.tableDataSource.findIndex(x => x.id === e.id);
        if (index > -1) {
            if (this.tableDataSource[index].hasOwnProperty(e.field)) {
                if (e.field === "owners") {
                    if (e.value && e.value["recipients"] !== undefined)
                        this.tableDataSource[index][e.field] = e.value["recipients"];
                }
                else {
                    this.tableDataSource[index][e.field] = e.value;
                }
            }
            this.tableDataSourceObs = of([...this.tableDataSource]);
        }
    }
    initMainForm() {
        this.mainForm = new FormGroup({
            propertyDetailsForm: this.initPropertyForm(),
            valuationForm: this.initValuationForm()
        });
    }
    itemsChecked(array) {
        this.selectedPvPt = array[0];
        this.onButtonEditClicked();
    }
    initPropertyForm() {
        return new FormGroup({
            editIndex: new FormControl(null),
            sgCodeEdit: new FormControl(null, [Validators.required]),
            descriptionEdit: new FormControl(null),
            addressEdit: new FormControl(null),
            erfNumberEdit: new FormControl(null),
            farmNumberEdit: new FormControl(null),
            unitNumberEdit: new FormControl(null),
            erfSizeEdit: new FormControl(null),
            improvementEdit: new FormControl(null),
            allotmentEdit: new FormControl(null),
            zoningEdit: new FormControl(null),
            subdivisionEdit: new FormControl(null),
            ownersEdit: new FormControl(null, [Validators.nullValidator])
        });
    }
    initValuationForm() {
        return new FormGroup({
            selectDate: new FormControl(null),
            openMarketValue: new FormControl(null),
            method: new FormControl(null),
            improvement: new FormControl(null),
            calculationDate: new FormControl(null),
            status: new FormControl(null),
            multiValues: new FormArray([]),
        });
    }
    selectValuation(event) {
        const valuationForm = this.mainForm.get(this.valuationFormName);
        this.selectPvValuation = this.pvValuations.find(f => f.id === valuationForm.get(this.selectDateCtrl).value);
        if (this.selectPvValuation !== undefined && this.selectPvValuation !== null) {
            valuationForm.get(this.openMarketCtrl).setValue(this.selectPvValuation.openMarketValue);
            valuationForm.get(this.methodCtrl).setValue(this.selectPvValuation.method);
            valuationForm.get(this.calculationDateCtrl).setValue(this.selectPvValuation.calculationDate);
            valuationForm.get(this.improvementCtrl).setValue(this.selectPvValuation.improvement);
        }
    }
    handleRouteChange() {
        this.initialiseForm();
    }
    loadApplication() {
        const params = {
            $expand: `properties, properties($expand=owners)`,
            $filter: `jobId eq ${this.jobID}`,
        };
        this.tableDataSourceObs = this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params).pipe(map(data => {
            data.value[0].properties.forEach(x => {
                x.publicFieldCardLink = getPropertyFieldCardLink(() => this.generateReport(x.id, ViewApplicationLocationPvConstants.FIELD_CARD_PUBLIC_REPORT));
                x.municipalFieldCardLink = getPropertyFieldCardLink(() => this.generateReport(x.id, ViewApplicationLocationPvConstants.FIELD_CARD_MUNICIPAL_REPORT));
            });
            this.tableDataSource = data.value[0].properties;
            // this.setShowMap();
            this.pvApplication = data.value[0];
            this.showMap = true;
            this.selectedPvPt = null;
            this.changeDetectorRefs.markForCheck();
            return data.value[0].properties;
        }));
        this.changeDetectorRefs.markForCheck();
    }
    generateReport(propertyId, reportType) {
        this.reportService.getReportGroupByGroupAndReportName(+this.appControllerService.selectedModuleID, reportType).subscribe(x => {
            let model;
            if (reportType == ViewApplicationLocationPvConstants.FIELD_CARD_PUBLIC_REPORT)
                model = setPublicFieldCardParameters(x, propertyId, +this.appControllerService.selectedModuleID);
            else if (reportType == ViewApplicationLocationPvConstants.FIELD_CARD_MUNICIPAL_REPORT)
                model = setMunicipalFieldCardParameters(x, propertyId, +this.appControllerService.selectedModuleID);
            this.reportService.generateReport(model).pipe(take(1)).subscribe({
                next: (response) => {
                    handleReportDownload(response, model);
                },
                error: (error) => {
                    this.appControllerService.handleServerErrorMessage(ViewApplicationLocationPvConstants.name, error, CRUDOperation.Get);
                }
            });
        });
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.propertyLayer = this.mapService.userMaps.find(a => a.selectionLayerType.toLowerCase() === "property").layer;
        this.zoningLayer = this.mapService.userMaps.find(a => a.selectionLayerType.toLowerCase() === "property zone").layer;
        this.syncMapGeometries();
        this.updateDefinitionExpression();
        this.changeDetectorRefs.detectChanges();
    }
    syncMapGeometries() {
        const geomArray = [];
        const blockArray = [];
        this.tableDataSource.forEach((prop) => {
            const geom = new Polygon(WktConverterUtils.ConvertWktToArcGisJson(prop.shape, 102100));
            geomArray.push(GeometryUtils.mapGeometryToDTO(geom));
        });
        blockArray.push(GeometryUtils.mapGeometryToDTO(new Polygon(WktConverterUtils.ConvertWktToArcGisJson(this.pvApplication.shape, 102100))));
        this.mapComponent.addGeometriesOnMap(blockArray, this.blockLayerName, true, false, this.blockSymbol);
        this.mapComponent.addGeometriesOnMap(geomArray, this.propertyLayerName, true, false);
    }
    syncMapSelectedGeometries(shape) {
        const geomArray = [];
        const geom = new Polygon(WktConverterUtils.ConvertWktToArcGisJson(shape, 102100));
        geomArray.push(GeometryUtils.mapGeometryToDTO(geom));
        this.mapComponent.addGeometriesOnMap(geomArray, this.propertyLayerName, false, false, this.selectedSymbol);
    }
    propertyDataAlternateColumnName(propertyObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(propertyObject)) {
            if (key === name1) {
                returnVal = propertyObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = propertyObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = propertyObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    updateDefinitionExpression() {
        if (this.pvApplication && this.pvApplication.propertyType) {
            const zonings = [];
            let searchNull = false;
            this.propertyTypesOptions.forEach(item => {
                if (item.code === this.pvApplication.propertyType) {
                    if (item.code.toLowerCase() === "no zone information" || item.value.toLowerCase() === "no zone information"
                        || item.value.toLowerCase() === "null" || item.value.toLowerCase() === "") {
                        searchNull = true;
                    }
                    else {
                        zonings.push(item);
                    }
                }
            });
            this.zones = zonings;
            this.zoningFilterString = "";
            if (zonings.length > 0) {
                const propertyString = zonings.join("','");
                this.zoningFilterString = `Zoning in ('${propertyString}')`;
            }
            if (searchNull) {
                if (this.zoningFilterString !== "") {
                    this.zoningFilterString += " or ";
                }
                this.zoningFilterString += `Zoning is null`;
            }
            if (this.zoningLayer)
                this.zoningLayer.definitionExpression = this.zoningFilterString;
        }
    }
    setProperties(property) {
        const prop = {
            id: this.idVal,
            sgCode: this.propertyDataAlternateColumnName(property.attributes, "SgCode", "sgcode"),
            address: this.propertyDataAlternateColumnName(property.attributes, "Address", "address"),
            erfSize: this.propertyDataAlternateColumnName(property.attributes, "ErfSize", "erfSize"),
            farmNumber: this.propertyDataAlternateColumnName(property.attributes, "FarmNumber", "farmNumber"),
            erfNumber: this.propertyDataAlternateColumnName(property.attributes, "ErfNumber", "erfNumber"),
            unitNumber: this.propertyDataAlternateColumnName(property.attributes, "UnitNumber", "unitNumber"),
            description: this.propertyDataAlternateColumnName(property.attributes, "Description", "description"),
            improvement: this.propertyDataAlternateColumnName(property.attributes, "Improvement", "improvement"),
            deleted: false,
            shape: WktConverterUtils.ConvertArcGISJsonToWkt(property.geometry.toJSON()),
            wkid: 102100,
            subdivision: this.propertyDataAlternateColumnName(property.attributes, "PtnNum", "subdivision"),
            owners: [],
        };
        this.tableDataSource.push(prop);
        this.idVal--;
        this.tableDataSourceObs = of([...this.tableDataSource]);
        ////////////////////////////////////
        ////////////////////////////////////
        this.changeDetectorRefs.detectChanges();
    }
    getValuation() {
        this.subscriptions.add(this.viewBlockPropertiesPvService.get(this.selectedPvPt.id).subscribe(resp => {
            this.pvValuations = resp;
            this.pvValuations.forEach(el => {
                el.calculationDate = this.datePipe.transform(el.calculationDate, "yyyy/MM/dd hh:mm");
            });
            // this.populate(this.selectedPvPt);
            this.changeDetectorRefs.markForCheck();
        }));
    }
    initialiseForm() {
        const filterString = `stepName eq \'Start\' AND moduleId eq ${this.moduleID}`;
        const params = {
            $filter: filterString
        };
        this.subscriptions.add(this.viewApplicationService.getStepMetaObservable(params).subscribe((metadata) => {
            this.loadMetadata(JSON.parse(metadata.value[0].metadata));
            this.loadApplication();
        }));
    }
    loadMetadata(stepMeta) {
        try {
            this.ownerGroups = stepMeta.ownerGroup;
            if (this.ownerGroups[0].hasOwnProperty("requiredFields") && this.ownerGroups[0].requiredFields !== null) {
                this.ownerGroups = this.recipientSelectService.checkStepMetaRecipientGroups(this.ownerGroups);
            }
            // if (this.aflaModuleStrategyService.lookups.has("propertyTypes")) {
            //   this.propertyTypesOptions = this.aflaModuleStrategyService.lookups.get("propertyTypes");
            //   this.updateDefinitionExpression();
            // } else {
            this.getLookups();
            // }
        }
        catch (e) {
            this.appControllerService.showMessage(SharedConstants.INVALID_METADATA, AlertType.Error);
        }
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.moduleID}  and (name eq 'PropertyType')`
        };
        this.subscriptions.add(this.viewApplicationService
            .getLookupsObservable(params)
            .subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
                // this.getApplicantData();
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage("View block properties", error, CRUDOperation.Get);
            }
        }));
    }
    onGetLookupsCompleted(response) {
        const propertyTypes = [];
        if (response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "PropertyType") {
                    propertyTypes.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("propertyTypes", propertyTypes);
        this.propertyTypesOptions = propertyTypes;
        this.updateDefinitionExpression();
        this.changeDetectorRefs.detectChanges();
    }
    onBtnRemoveClicked() {
        if (!this.selectedPvPt) {
            this.appControllerService.showMessage(SharedConstants.NO_ITEM_SELECTED, AlertType.Warning);
            return;
        }
        if (this.selectedPvPt) {
            const dialogRef = this.modalService.open(PopUpComponent, this.options);
            dialogRef.componentInstance.title = ViewApplicationLocationPvConstants.DELETE_PROPERTY_TITLE;
            dialogRef.componentInstance.contentMessage =
                ViewApplicationLocationPvConstants.DELETE_PROPERTIES_CONFIRM;
            dialogRef.componentInstance.data = this.selectedPvPt;
            dialogRef.result
                .then((ok) => {
                if (ok) {
                    this.deleteProperty();
                }
            })
                .catch((res) => {
            });
        }
    }
    deleteProperty() {
        this.deletePvPropretyObs = new Array();
        // this.selectedPvProperties.forEach(element =>{
        const index = this.tableDataSource.findIndex(p => p.id === this.selectedPvPt.id);
        if (index > -1) {
            if (this.tableDataSource[index].id > 0)
                this.deletePvPropretyObs.push(this.deletePvPropretySubscription = this.propertyValuationService.deletePvProprety(this.selectedPvPt.id));
            this.tableDataSource.splice(index, 1);
        }
        this.subscriptions.add(forkJoin(this.deletePvPropretyObs).subscribe(resp => {
            this.appControllerService.showMessage(SharedConstants.REMOVE_SUCCESS, AlertType.Success);
        }, (error) => {
            this.appControllerService.handleServerErrorMessage("View Application Location Pv", error, CRUDOperation.Delete);
        }));
        this.tableDataSourceObs = of([...this.tableDataSource]);
        this.syncMapGeometries();
        this.changeDetectorRefs.markForCheck();
    }
    validateData(element) {
        if (((!element.erfNumber || element.erfNumber == null || element.erfNumber === undefined)
            && (!element.farmNumber || element.farmNumber == null || element.farmNumber === undefined))
            || (!element.sgCode || element.sgCode == null || element.sgCode === undefined)) {
            return false;
        }
        return true;
    }
    handleSaveProperties() {
        this.postPvPropretiesObs = new Array();
        this.patchPvPropretiesObs = new Array();
        let notValidCount = 0;
        for (let elmt of this.tableDataSource) {
            const element = JSON.parse(JSON.stringify(elmt));
            delete element["selected"];
            if (element.id < 0) {
                const id = element.id;
                element.id = 0;
                element.valuationBlockId = this.pvApplication.id;
                element.unitNumber = element.unitNumber.toString();
                const erfSize = +element["erfSize"];
                delete element["erfSize"];
                element["erfSize"] = erfSize;
                const owners = element.owners;
                delete element.owners;
                if (elmt["zoning"])
                    if (Object.prototype.hasOwnProperty.call(elmt["zoning"], "value"))
                        element.zoning = elmt["zoning"]["value"];
                    else
                        element.zoning = elmt["zoning"];
                if (!this.validateData(element)) {
                    notValidCount++;
                }
                this.postPvPropretiesObs.push(this.propertyValuationService.postPvProprety(element).pipe(tap(rslt => {
                    const index = this.tableDataSource.findIndex(x => x.id === id);
                    this.tableDataSource[index] = { ...rslt };
                    if (rslt && rslt.id) {
                        owners.forEach(r => {
                            r = { ...RecipientUtils.removeRecipientProperties(r) };
                        });
                        this.subscriptions.add(this.propertyValuationService.postPvPropretySetOwners(rslt.id, { owners: owners }).subscribe(r => {
                        }));
                    }
                })));
            }
            else if (element.id > 0) {
                const element = JSON.parse(JSON.stringify(elmt));
                const id = element.id;
                const owners = element.owners;
                delete element.id;
                delete element.valuationBlockId;
                delete element.deleted;
                delete element["appealId"];
                delete element["objectionId"];
                delete element["selected"];
                delete element.owners;
                const erfSize = +element["erfSize"];
                delete element["erfSize"];
                element["erfSize"] = erfSize;
                if (elmt["zoning"])
                    if (Object.prototype.hasOwnProperty.call(elmt["zoning"], "value"))
                        element.zoning = elmt["zoning"]["value"];
                    else
                        element.zoning = elmt["zoning"];
                if (!this.validateData(element)) {
                    notValidCount++;
                }
                this.patchPvPropretiesObs.push(this.propertyValuationService.patchPvProprety(id, element).pipe(tap(rslt => {
                    const index = this.tableDataSource.findIndex(x => x.id === id);
                    this.tableDataSource[index] = { ...rslt };
                    if (rslt && rslt.id) {
                        owners.forEach(r => {
                            r = { ...RecipientUtils.removeRecipientProperties(r) };
                        });
                        this.subscriptions.add(this.propertyValuationService.postPvPropretySetOwners(rslt.id, { owners: owners }).subscribe(r => {
                        }));
                    }
                })));
            }
        }
        if (notValidCount > 0) {
            this.appControllerService.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
            return;
        }
        const allObservable = new Array();
        allObservable.push(...this.postPvPropretiesObs);
        allObservable.push(...this.patchPvPropretiesObs);
        this.subscriptions.add(forkJoin(allObservable).subscribe((resp) => {
            this.appControllerService.showMessage(SharedConstants.ADD_SUCCESS, AlertType.Success);
            this.loadApplication();
        }, (error) => {
            this.appControllerService.handleServerErrorMessage("View Application Location Pv", error, CRUDOperation.Add);
        }));
    }
    subscribeToProperty() {
        this.selectedPropertyGraphic = this.mapService.$selectedProperty;
        this.subscriptions.add(this.selectedPropertyGraphic.subscribe(property => {
            if (property !== null) {
                this.requestStatusService.showBusySpinner("subscribeToProperty");
                const sgCode = property.attributes.hasOwnProperty("SgCode") ? property.attributes.SgCode : "";
                let found = false;
                this.tableDataSource.forEach(item => {
                    const check = item.sgCode;
                    if (check === sgCode) {
                        found = true;
                        this.appControllerService.showMessage(ViewApplicationLocationPvConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                        this.requestStatusService.removeBusySpinner("subscribeToProperty");
                    }
                });
                if (!found) {
                    this.setProperties(property);
                    this.syncMapGeometries();
                    this.requestStatusService.removeBusySpinner("subscribeToProperty");
                }
            }
        }));
    }
    onButtonCancelClicked() {
        this.propertyDetailsForm.reset();
        // this.propertyDetailsForm.disable();
        this.selectPvValuation = null;
    }
    onButtonEditClicked() {
        this.selectPvValuation = null;
        if (!this.selectedPvPt) {
            this.appControllerService.showMessage(this.selectPromptMessage, AlertType.Warning, true);
            return;
        }
        this.propertyDetailsForm.get("editIndex").setValue(this.selectedPvPt.id);
        this.propertyDetailsForm.get(ViewEditPropertyDetailsPvConstants.SG_CODE_CONTROL_NAME).setValue(this.selectedPvPt.sgCode);
        this.propertyDetailsForm.get(ViewEditPropertyDetailsPvConstants.ADDRESS_CONTROL_NAME).setValue(this.selectedPvPt.address);
        this.propertyDetailsForm.get(ViewEditPropertyDetailsPvConstants.DESCRIPTION_CONTROL_NAME).setValue(this.selectedPvPt.description);
        this.propertyDetailsForm.get(ViewEditPropertyDetailsPvConstants.ERF_NUMBER_CONTROL_NAME).setValue(this.selectedPvPt.erfNumber);
        this.propertyDetailsForm.get(ViewEditPropertyDetailsPvConstants.FARM_NUMBER_CONTROL_NAME).setValue(this.selectedPvPt.farmNumber);
        this.propertyDetailsForm.get(ViewEditPropertyDetailsPvConstants.UNIT_NUMBER_CONTROL_NAME).setValue(this.selectedPvPt.unitNumber);
        this.propertyDetailsForm.get(ViewEditPropertyDetailsPvConstants.ERF_SIZE_CONTROL_NAME).setValue(this.selectedPvPt.erfSize);
        this.propertyDetailsForm.get(ViewEditPropertyDetailsPvConstants.IMPROVEMENT_CONTROL_NAME).setValue(this.selectedPvPt.improvement);
        this.propertyDetailsForm.get(ViewEditPropertyDetailsPvConstants.SUBDIVISION_PORTION_NUMBER_CONTROL_NAME).setValue(this.selectedPvPt.subdivision);
        const ownerControl = this.propertyDetailsForm.get("ownersEdit");
        ownerControl.reset();
        this.changeDetectorRefs.detectChanges();
        if (this.selectedPvPt.owners && this.selectedPvPt.owners.length > 0)
            this.recipientSelectService.setRecipients(this.selectedPvPt.owners, true, ownerControl);
        this.syncMapGeometries();
        this.getValuation();
        this.syncMapSelectedGeometries(this.selectedPvPt.shape);
    }
    onBtnSaveClicked() {
        this.handleSaveProperties();
    }
    static ctorParameters = () => [
        { type: ViewBlockPropertiesPvService },
        { type: RecipientListService },
        { type: PropertyValuationService },
        { type: MapService },
        { type: AppControllerService },
        { type: ActivatedRoute },
        { type: RequestStatusService },
        { type: ViewApplicationService },
        { type: RouterParamsService },
        { type: AflaModuleStrategyService },
        { type: DatePipe },
        { type: NgbModal },
        { type: ChangeDetectorRef },
        { type: ReportService }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: false },] }]
    };
};
ViewBlockPropertiesPvComponent = __decorate([
    Component({
        selector: "app-view-block-properties-pv",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], ViewBlockPropertiesPvComponent);
export { ViewBlockPropertiesPvComponent };
